import React from "react";
// import blueLogo from "../assests/brand/brand-logo.png";
// import whiteLogo from "../assests/brand/brand-logo-w.png";
// import { useThemeMode } from "../context/ThemeContext";
// import { useBranding } from "../context/BrandingContext";
import whiteLogo from "../assests/newbrand/logo-white.webp";
import blueLogo from "../assests/newbrand/logo.webp";
import { useThemeMode } from "../context/ThemeContext";
import { useBranding } from "../context/BrandingContext";

const sizeMap = {
  sm: "w-20 md:w-24",
  md: "w-28 md:w-30",
  lg: "w-40 md:w-40",
};

const BrandLogo = ({
  variant = "auto",
  size = "md",
  className = "",
  alt,
}) => {
  const { mode } = useThemeMode();
  const { settings, mediaUrl, companyName } = useBranding();

  const preferDark =
    variant === "white" || (variant === "auto" && mode === "dark");
  const remote = preferDark
    ? settings?.logoDarkUrl || settings?.logoLightUrl
    : settings?.logoLightUrl || settings?.logoDarkUrl;

  const logoSrc = remote
    ? mediaUrl(remote)
    : preferDark
      ? whiteLogo
      : blueLogo;

  return (
    <img
      src={logoSrc}
      alt={alt || companyName || "Brand Logo"}
      loading="lazy"
      className={`object-contain ${sizeMap[size] || sizeMap.md} ${className}`}
    />
  );
};

export default BrandLogo;
